'use client'
import { useState } from 'react'

export const useIsIOS = (): { isIOS: boolean } => {
  const [isIOS, _] = useState(() => {
    if (typeof navigator === 'undefined' || !navigator.userAgent) {
      return false
    }
    return /iphone|ipad|ipod/i.test(navigator.userAgent)
  })
  return { isIOS }
}
